import HeadlineField from './HeadlineField/HeadlineField';

const HeadlineFieldDirective = reactDirective => {
  return reactDirective(HeadlineField, undefined, { restrict: 'E' }, {});
};

HeadlineFieldDirective.$inject = ['reactDirective'];

export default HeadlineFieldDirective;
